
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class FranchiseeDialog extends Serenity.EntityDialog<FranchiseeRow, any> {
        protected getFormKey() { return FranchiseeForm.formKey; }
        protected getIdProperty() { return FranchiseeRow.idProperty; }
        protected getLocalTextPrefix() { return FranchiseeRow.localTextPrefix; }
        protected getNameProperty() { return FranchiseeRow.nameProperty; }
        protected getService() { return FranchiseeService.baseUrl; }
        protected getDeletePermission() { return FranchiseeRow.deletePermission; }
        protected getInsertPermission() { return FranchiseeRow.insertPermission; }
        protected getUpdatePermission() { return FranchiseeRow.updatePermission; }

        protected form = new FranchiseeForm(this.idPrefix);

        constructor() {
            super();
            

                this.form.IsGstInApplied.change(e => {
                    if (this.form.IsGstInApplied.value == false) {
                        this.form.Gstin.getGridField().toggle(false);
                        this.form.Pan.getGridField().toggle(false);
                        this.form.GstCertificate.getGridField().toggle(false);
                        Serenity.EditorUtils.setRequired(this.form.Gstin, false);
                    }
                    else {
                        this.form.Gstin.getGridField().toggle(true);
                        this.form.Pan.getGridField().toggle(true);
                        this.form.GstCertificate.getGridField().toggle(true);
                        Serenity.EditorUtils.setRequired(this.form.Gstin, true);
                    }
                }
                );

                

            
        }
        loadEntity(entity: FranchiseeRow) {
            super.loadEntity(entity);
            this.form.IsGstInApplied.change(e => {
                if (this.form.IsGstInApplied.value == false) {
                    this.form.Gstin.getGridField().toggle(false);
                    this.form.Pan.getGridField().toggle(false);
                    this.form.GstCertificate.getGridField().toggle(false);
                    Serenity.EditorUtils.setRequired(this.form.Gstin, false);
                }
                else {
                    this.form.Gstin.getGridField().toggle(true);
                    this.form.Pan.getGridField().toggle(true);
                    this.form.GstCertificate.getGridField().toggle(true);
                    Serenity.EditorUtils.setRequired(this.form.Gstin, true);
                }
            }
            );

            if (this.isNew()) {
                const hasGstinValue = this.form.Gstin.value !== "";

                this.form.Gstin.getGridField().toggle(false);
                this.form.Pan.getGridField().toggle(false);
                this.form.GstCertificate.getGridField().toggle(false);



                this.form.Gstin.getGridField().toggle(!hasGstinValue);
                this.form.Pan.getGridField().toggle(hasGstinValue);
                this.form.GstCertificate.getGridField().toggle(hasGstinValue);

                // Disable Pan and Certificate fields if Gstin has a value
                this.form.Pan.getGridField().toggle(hasGstinValue);
                this.form.GstCertificate.getGridField().toggle(hasGstinValue);

                if (this.form.IsGstInApplied.value == true) {
                    Serenity.EditorUtils.setRequired(this.form.Gstin, true);
                    this.form.Gstin.getGridField().toggle(true);
                    this.form.Gstin.getGridField().toggle(!hasGstinValue);
                    this.form.Pan.getGridField().toggle(hasGstinValue);
                    this.form.GstCertificate.getGridField().toggle(hasGstinValue);

                    // Disable Pan and Certificate fields if Gstin has a value
                    this.form.Pan.getGridField().toggle(hasGstinValue);
                    this.form.GstCertificate.getGridField().toggle(hasGstinValue);
                }
                else {
                    Serenity.EditorUtils.setRequired(this.form.Gstin, false);
                    this.form.Gstin.getGridField().toggle(false);
                    this.form.Pan.getGridField().toggle(hasGstinValue);
                    this.form.GstCertificate.getGridField().toggle(hasGstinValue);

                }
            }
            else {
                const hasGstinValue = this.form.Gstin.value !== "";

                this.form.Gstin.getGridField().toggle(false);
                this.form.Pan.getGridField().toggle(false);
                this.form.GstCertificate.getGridField().toggle(false);
                if (this.form.IsGstInApplied.value==true)
                {
                    Serenity.EditorUtils.setRequired(this.form.Gstin, true);
                    this.form.Gstin.getGridField().toggle(true);
                    this.form.Gstin.getGridField().toggle(!hasGstinValue);
                    this.form.Pan.getGridField().toggle(hasGstinValue);
                    this.form.GstCertificate.getGridField().toggle(hasGstinValue);

                    // Disable Pan and Certificate fields if Gstin has a value
                    this.form.Pan.getGridField().toggle(hasGstinValue);
                    this.form.GstCertificate.getGridField().toggle(hasGstinValue);
                }
                else {
                    Serenity.EditorUtils.setRequired(this.form.Gstin, false);
                    this.form.Gstin.getGridField().toggle(false);
                    this.form.Pan.getGridField().toggle(hasGstinValue);
                    this.form.GstCertificate.getGridField().toggle(hasGstinValue);

                }


               
            }

        }
    }
}